import { createDefault } from "../utils/ConstUtils";

export default createDefault([
  { value: 0, text: " " },
  { value: 1, text: "ヤマト運輸" },
  { value: 2, text: "佐川急便" },
  { value: 3, text: "その他" },
]);
